import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class EvaluationTreeResolver  {
    constructor(private apiService: ApiServiceService,
      private loader: LoaderFactory) { }

    resolve(route: ActivatedRouteSnapshot) {
      this.loader.openLoader('evaluation-info-tree');
      return this.apiService.getWithTranslate('tree/translated/'+route.params['evaluationId'])
        .then((data:any)=>{
          return data;
        })
    }
}
